import type { DocumentSettingsType } from 'components/editor/SidePanel/DocumentSettings/DocumentDesignSettings/DocumentSettingsContext';
import type { SectionStyles } from 'components/editor/Sections/Section.model';
import { DEFAULT_PAGE_SIZE, getPageSizeForOrientation, type PageSize } from 'components/editor/shared/gridConfig';
import { ContentType } from 'utils/getContentType';

// Not gated by editor-page-size: that flag only controls changing the size, a stored size is always used.
// SECTION content has no page size yet (FEN-4125), so it always uses the orientation-based US Letter size.
export function computeEffectivePageSize(
  contentType: ContentType,
  documentSettings: Pick<DocumentSettingsType, 'pageSize'> | undefined,
  sectionStyles: Pick<SectionStyles, 'pageOrientation'> | undefined
): PageSize {
  if (contentType === ContentType.SECTION) return getPageSizeForOrientation(undefined, sectionStyles?.pageOrientation);
  return documentSettings?.pageSize ?? DEFAULT_PAGE_SIZE;
}
